import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看全部",
}: SectionHeadingProps) {
  return (
    <div className="mb-5 flex items-end justify-between gap-4 md:mb-6">
      <div>
        <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950 md:text-2xl">
          <span className="h-5 w-1 rounded-full bg-accent-500 md:h-6"></span>
          {title}
        </h2>
        {subtitle && <p className="mt-1.5 text-xs text-foreground-500 md:text-sm">{subtitle}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex items-center gap-1 whitespace-nowrap text-xs font-medium text-foreground-500 transition-colors hover:text-primary-700 md:text-sm"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      )}
    </div>
  );
}